import React from 'react';
import { ContentLoader } from '../ContentLoader';
import { useStatesForEducationForm } from './graphql';
import { Alert, Box, DateField, SingleSelectField, TextField, useWatch } from '@medely/ui-kit';
import { DEGREE_PROGRAM_OPTIONS } from './constants';

type EducationFormFieldsProps = {
  assignmentChecklistVariant: boolean;
};

export const EducationFormFields = ({ assignmentChecklistVariant }: EducationFormFieldsProps) => {
  const { states, isLoading: isLoadingStates } = useStatesForEducationForm();

  const statesOptions = states.map(({ name, id }) => ({
    value: id as number,
    label: name as string,
  }));

  const city = useWatch({ name: 'city' });

  const showInfoText = assignmentChecklistVariant && !city;

  return (
    <ContentLoader loading={isLoadingStates}>
      <>
        {showInfoText && (
          <Box p={1} mb={2}>
            <Alert
              description="Complete highlighted fields to continue with your application"
              severity="warning"
              testId="education-modal-complete-highlighted-fields"
              hideCloseIcon
            />
          </Box>
        )}
        <Box testId="education-modal-school-name">
          <TextField name="school_name" placeholder="School *" />
        </Box>
        <Box py={1} testId="education-modal-city-name">
          <TextField name="city" placeholder="City *" />
        </Box>
        <Box testId="education-modal-state" pt={1}>
          <SingleSelectField
            placeholder="State *"
            label=""
            name="state_id"
            options={statesOptions}
          />
        </Box>
        <Box testId="education-modal-degree-type" pt={1}>
          <SingleSelectField
            label=""
            placeholder="Degree/Program *"
            name="degree_type"
            options={DEGREE_PROGRAM_OPTIONS}
          />
        </Box>
        <Box py={1} testId="education-modal-field-of-study">
          <TextField name="field_of_study" label="" placeholder="Field of study *" />
        </Box>
        <Box testId="education-modal-end-date" pt={1}>
          <DateField name="end_date" label="Graduation date *" labelStyle="inline" />
        </Box>
      </>
    </ContentLoader>
  );
};
